import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition } from "vue";
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import SideBar from './components/SideBar/index.vue';
import NavBar from './components/NavBar/index.vue';
import store from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const isMobile = ref(false);
    let sidebarHideTimer;
    const updateViewport = () => {
      const mobile = window.innerWidth <= 768;
      isMobile.value = mobile;
      if (mobile && store.state.app.siderType) {
        store.commit('app/setSiderType');
      }
    };
    watch(() => [isMobile.value, store.state.app.siderType], ([mobile, sidebarOpen]) => {
      clearTimeout(sidebarHideTimer);
      sidebarHideTimer = undefined;
      if (mobile && sidebarOpen) {
        sidebarHideTimer = setTimeout(() => {
          if (isMobile.value && store.state.app.siderType) {
            store.commit('app/setSiderType');
          }
        }, 5000);
      }
    });
    onMounted(() => {
      updateViewport();
      window.addEventListener('resize', updateViewport);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateViewport);
      clearTimeout(sidebarHideTimer);
    });
    const asideWidth = computed(() => {
      if (isMobile.value) {
        return store.state.app.siderType ? '230px' : '0px';
      }
      return store.state.app.siderType ? '230px' : '64px';
    });
    return (_ctx, _cache) => {
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_header = _resolveComponent("el-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: _normalizeClass(["layout-container", {
          hideSidebar: !_ctx.$store.state.app.siderType,
          'mobile-layout': isMobile.value
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: asideWidth.value,
          class: _normalizeClass({
            'mobile-aside': isMobile.value
          })
        }, {
          default: _withCtx(() => [_createVNode(SideBar)]),
          _: 1
        }, 8, ["width", "class"]), _createVNode(_component_el_container, {
          class: "main-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createVNode(NavBar)]),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createVNode(_component_router_view, null, {
                default: _withCtx(({
                  Component
                }) => [_createVNode(_Transition, {
                  name: "fade-transform",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
                  _: 2
                }, 1024)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["class"]);
    };
  }
});